import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import EditIcon from '../../../../../../../../components/icons/EditIcon';

const propTypes = {
  values: PropTypes.shape({
    relationship: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
};

const MemorialEventReviewDetails = ({ values, onUpdate }) => {
  return (
    <>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Name of the deceased</h3>
              <p className="text-base">
                {values.first_name} {values.last_name}
              </p>
            </div>
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onUpdate}
              className="ml-auto review-step-edit-icon"
            >
              <EditIcon color="#0d84fe" size="22px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>
    </>
  );
};

MemorialEventReviewDetails.propTypes = propTypes;

export default MemorialEventReviewDetails;
